module.exports = __webpack_public_path__ + "static/media/optout.d05238f4.svg";